import React from "react"
import { processSilentRenew } from "redux-oidc"

const SignInSilent = () => {
  processSilentRenew()
  return (
    <div>
      &nbsp;
    </div>
  )
}

export default SignInSilent



// WEBPACK FOOTER //
// ./src/routes/auth/SignInSilent.jsx